exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-select[data-v-d4ed846e]{height:34px!important;border-radius:3px!important;padding:1px 8px}.small-description[data-v-d4ed846e]{line-height:11px}.b-group-item-end[data-v-d4ed846e]{display:flex!important;justify-content:space-between!important}.b-group-item-end b[data-v-d4ed846e]{text-transform:none}", ""]);

// exports
